import React from 'react';
import { motion } from 'framer-motion';
import CookieBanner from "./components/CookieBanner";
import { useEffect, useState } from "react";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0 }
};

const whatsappUrl =
  "https://wa.me/34641369866?text=Hola%2C%20quiero%20ayuda%20para%20organizar%20un%20viaje%20%F0%9F%98%8A";

const LandingPage = ({ setPage }) => {
  React.useEffect(() => {
  document.title = 'Biajando con B de Barato | Tu viaje ideal al mejor precio';
  const meta = document.createElement("meta");
  meta.name = "description";
  meta.content =
    "Viajes personalizados optimizados por WhatsApp. Sin comparar, sin líos. Te damos el viaje listo para reservar.";
  document.head.appendChild(meta);
}, []);

  const [scrolled, setScrolled] = React.useState(false);
React.useEffect(() => {
  const onScroll = () => setScrolled(window.scrollY > 10);
  window.addEventListener("scroll", onScroll);
  return () => window.removeEventListener("scroll", onScroll);
}, []);
  
  return (
    <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-blue-50 to-white flex flex-col pb-16">

   {/* HEADER */}
<header
  className={`sticky top-0 z-50 w-full bg-white/80 backdrop-blur-md border-b border-gray-100 transition-shadow ${
    scrolled ? "shadow-sm" : ""
  }`}
>
  <div className="w-full">
    <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

    {/* LOGO */}
    <img
      src="/logo-biajando.png"
  alt="Biajando con B de Barato"
  className="h-14 md:h-16"
    />

    {/* CTA */}
    <a
href={whatsappUrl}
  target="_blank"
      rel="noopener noreferrer"
      className="
        inline-flex items-center justify-center
        px-4 md:px-5 py-2.5
        rounded-full
        bg-indigo-600
        text-white text-sm md:text-base font-medium
        shadow-sm
        hover:bg-indigo-700
        transition
      "
    >
      Empieza gratis
    </a>
    </div>
  </div>
</header>

      {/* HERO */}
      <section
  className="relative w-full min-h-[60vh] md:min-h-[70vh] flex items-center"
  style={{
    backgroundImage: "url('/banner.png')",
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }}
>
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-900/50 via-blue-900/40 to-black/40" />

        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeUp}
          transition={{ duration: 0.7, ease: 'easeOut' }}
          className="relative z-10 max-w-xl px-5 md:px-12 text-white"
        >
          <h1 className="text-3xl md:text-5xl font-semibold leading-tight">
            Nos cuentas tu idea.<br />Nosotros la optimizamos por ti.
          </h1>
          <p className="mt-4 text-base md:text-lg text-white/90">
            Dinos fechas, presupuesto o destino. Buscamos por ti vuelos y alojamientos pensados para lo que buscas.
            Sin comparar, sin líos, sin perder tiempo.
          </p>
          <motion.a
href={whatsappUrl}
  target="_blank"
  rel="noopener noreferrer"
  initial={{ opacity: 0, y: 12 }}
  whileInView={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.6, ease: 'easeOut' }}
  viewport={{ once: true }}
  className="
    mt-6 md:mt-8
    w-full md:w-auto
    inline-flex items-center justify-center gap-3
    px-6 py-4 md:py-3
    rounded-full
    backdrop-blur-md bg-white/15
    border border-white/30
    text-white font-medium
    shadow-lg
    hover:bg-white/25
    transition
  "
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    className="h-5 w-5 fill-green-400"
  >
    <path d="M16.003 3C9.373 3 4 8.373 4 15.003c0 2.651.87 5.103 2.342 7.08L4 29l7.107-2.296a11.94 11.94 0 0 0 4.896 1.045h.001C22.633 27.75 28 22.378 28 15.75 28 9.123 22.633 3 16.003 3z"/>
  </svg>

 <span className="text-sm md:text-base">
    Organiza tu viaje por WhatsApp
  </span>
</motion.a>
        </motion.div>
      </section>

{/* CÓMO FUNCIONA */}
<motion.section
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
  transition={{ duration: 0.6 }}
className="w-full max-w-7xl mt-16"
>
  <div className="p-6 md:p-12">

    <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 text-center">
      Así funciona Biajando, paso a paso
    </h2>

    <p className="mt-3 text-gray-600 text-center max-w-3xl mx-auto text-sm md:text-base">
      Todo sucede por WhatsApp. Definimos tu idea poco a poco y te entregamos una propuesta optimizada, lista para decidir.
    </p>

    <div className="mt-10 space-y-3 md:space-y-4">

      {[
  {
    title: 'Inicias la conversación por WhatsApp',
    text: 'Empiezas con una idea, un presupuesto o sin tenerlo claro.'
  },
  {
    title: 'El agente concreta tu viaje',
    text: 'Te hace preguntas clave sobre fechas, tipo de viaje e intereses.'
  },
  {
    title: 'Optimizamos tu viaje',
    text: 'Optimizamos vuelos, alojamientos y transportes según tus prioridades.'
  },
  {
    title: 'Recibes un resumen orientativo',
    text: 'Te enviamos gratuitamente un resumen por email para validar el viaje.'
  },
  {
    title: 'Propuesta final lista para reservar',
    text: 'Si quieres cerrar el viaje, revisamos todo y te enviamos enlaces directos. Este paso final es de pago, con un coste muy reducido.'
  }
].map((step, i) => (
        <div
          key={i}
         className="group relative flex gap-4 rounded-2xl border border-gray-100 bg-gray-50/50 px-4 py-4 md:p-5 transition md:hover:bg-gray-50 md:hover:border-gray-200"
        >
          {/* Número */}
          <div className="flex-shrink-0 relative z-10">
            <div className="w-9 h-9 rounded-full bg-indigo-600 text-white text-sm font-medium flex items-center justify-center">
              {i + 1}
            </div>
          </div>

          {/* Contenido */}
          <div>
            <h3 className="font-medium text-gray-900 text-sm md:text-base">
              {step.title}
            </h3>
            <p className="mt-1 text-gray-600 text-sm leading-snug md:leading-relaxed">
              {step.text}
            </p>
          </div>

          {/* Línea de proceso */}
          <span className="absolute left-8 top-14 bottom-3 w-[2px] bg-indigo-600/20 group-last:hidden" />
        </div>
      ))}

    </div>

  </div>
</motion.section>

{/* DOSIER DE VIAJE */}
<motion.section
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
  transition={{ duration: 0.6 }}
  className="w-full max-w-7xl mt-20"
>
  <div className="bg-white shadow-sm p-6 md:p-12">

    {/* TÍTULO */}
    <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 text-center">
      Así se ve tu viaje, listo para reservar
    </h2>

    <p className="mt-3 text-center text-gray-600 max-w-2xl mx-auto text-sm md:text-base">
      Cuando el viaje está definido, te enviamos un dosier claro y ordenado con todo optimizado y enlaces directos.
    </p>

    {/* DOSIER */}
    <div className="mt-10 rounded-2xl border bg-gray-50 p-5 md:p-8">

      {/* HEADER DOSIER */}
      <div className="flex items-center justify-between mb-6">
        <div>
          <p className="text-sm text-gray-500">Propuesta de viaje</p>
          <p className="font-semibold text-gray-900">Roma · 3 noches</p>
        </div>
        <span className="inline-flex px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold">
          Ejemplo real
        </span>
      </div>

      {/* GRID PRINCIPAL */}
      <div className="grid gap-4 md:grid-cols-2">

        {/* VUELOS */}
        <div className="bg-white rounded-xl p-4 border">
          <p className="text-sm font-medium text-gray-900 mb-1">✈️ Vuelos</p>
          <p className="text-sm text-gray-600">
            Valencia → Roma<br />
            Ida: vie 08:15 · Vuelta: dom 20:40
          </p>
          <span className="mt-2 inline-block text-sm text-indigo-600 font-medium">
            Enlace directo de compra
          </span>
        </div>

        {/* HOTEL */}
        <div className="bg-white rounded-xl p-4 border">
          <p className="text-sm font-medium text-gray-900 mb-1">🏨 Alojamiento</p>
          <p className="text-sm text-gray-600">
            Hotel céntrico ⭐⭐⭐⭐<br />
            2 noches · habitación doble
          </p>
          <span className="mt-2 inline-block text-sm text-indigo-600 font-medium">
            Enlace de reserva
          </span>
        </div>

        {/* TRANSPORTE */}
        <div className="bg-white rounded-xl p-4 border">
          <p className="text-sm font-medium text-gray-900 mb-1">🚆 Desplazamientos</p>
          <p className="text-sm text-gray-600">
            Aeropuerto → centro<br />
            Tren incluido
          </p>
          <span className="mt-2 inline-block text-sm text-indigo-600 font-medium">
            Ver billetes
          </span>
        </div>

        {/* CONSEJOS */}
        <div className="bg-white rounded-xl p-4 border">
          <p className="text-sm font-medium text-gray-900 mb-1">💡 Consejos útiles</p>
          <ul className="text-sm text-gray-600 list-disc list-inside space-y-1">
            <li>Mejor zona para alojarse</li>
            <li>Día óptimo para visitar el Vaticano</li>
            <li>Evitar colas innecesarias</li>
          </ul>
        </div>

      </div>

      {/* RESUMEN PRECIOS */}
      <div className="mt-6 border-t pt-5">
        <div className="grid gap-4 md:grid-cols-3 md:items-center">

          {/* DATOS */}
          <div className="text-sm text-gray-600">
            2 personas<br />
            1 destino · 3 noches
          </div>

          {/* PRECIO HABITUAL */}
          <div className="text-sm text-gray-400 md:text-center">
            Búsqueda estándar sin optimizar<br />
            <span className="line-through">420 € / persona</span>
          </div>

          {/* PRECIO OPTIMIZADO */}
          <div className="text-sm md:text-right">
            <span className="block text-gray-600">Propuesta optimizada con Biajando</span>
            <span className="font-semibold text-indigo-700 text-lg">
              215 € / persona
            </span>
          </div>

        </div>

        <p className="mt-3 text-xs text-gray-500 text-center">
          Optimizado según fechas, horarios y ubicación.
        </p>
      </div>

    </div>

    {/* COPY FINAL */}
    <p className="mt-6 text-center text-sm text-gray-600 max-w-3xl mx-auto">
      No vendemos vuelos ni hoteles.
      Te damos el viaje ya pensado, con todo enlazado,
      para que reserves en minutos sin complicarte.
    </p>

    {/* CTA SUAVE */}
    <div className="mt-6 flex justify-center">
      <a
href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="
          inline-flex items-center gap-2
          px-5 py-2.5
          rounded-full
          bg-indigo-600
          text-white text-sm font-medium
          shadow-sm
          hover:bg-indigo-700
          transition
        "
      >
        Quiero un viaje así
      </a>
    </div>

  </div>
</motion.section>

{/* RESEÑAS */}
<section className="w-full max-w-7xl mt-20">
  <div className="bg-white  shadow-sm p-6 md:p-12">

    {/* Cabecera */}
    <div className="max-w-3xl mb-10">
      <h2 className="text-2xl md:text-3xl font-semibold text-gray-900">
        Opiniones de personas que no querían complicarse
      </h2>
      <p className="mt-3 text-gray-600 text-sm md:text-base">
        Personas con ganas de viajar, no de organizar.
      </p>
    </div>

    {/* Reseñas */}
    <div className="grid gap-6 md:grid-cols-3">

      {/* Pareja */}
      <div className="relative rounded-2xl border border-gray-100 bg-gray-50/50 p-6">
        <span className="absolute -top-4 left-5 text-4xl text-indigo-300">“</span>
        <p className="text-sm text-gray-800 leading-relaxed">
          Queríamos viajar a París un fin de semana sin perder tiempo comparando opciones.
A través de WhatsApp definimos el viaje y recibimos una propuesta clara, bien organizada y fácil de reservar.
Nos ayudó a decidir rápido y con tranquilidad.
        </p>
        <div className="mt-4 text-xs text-gray-500">
          <span className="font-medium text-gray-900">Laura y Dani</span><br />
          París · fin de semana
        </div>
      </div>

      {/* Grupo Budapest */}
      <div className="relative rounded-2xl border border-gray-100 bg-gray-50/50 p-6">
        <span className="absolute -top-4 left-5 text-4xl text-indigo-300">“</span>
        <p className="text-sm text-gray-800 leading-relaxed">
          Éramos cuatro y ninguno tenía ganas de organizar nada.
          Al final quedó un viaje a Budapest bastante apañado
          y sin discutir por el grupo de WhatsApp.
        </p>
        <div className="mt-4 text-xs text-gray-500">
          <span className="font-medium text-gray-900">Marcos</span><br />
          Budapest · 5 días · 4 amigos
        </div>
      </div>

      {/* Grupo Tailandia */}
      <div className="relative rounded-2xl border border-gray-100 bg-gray-50/50 p-6">
        <span className="absolute -top-4 left-5 text-4xl text-indigo-300">“</span>
        <p className="text-sm text-gray-800 leading-relaxed">
          Organizar Tailandia para seis personas daba una pereza increíble.
          Nos pasaron todo bastante claro y con enlaces.
          Así fue mucho más fácil decir “sí, tiramos”.
        </p>
        <div className="mt-4 text-xs text-gray-500">
          <span className="font-medium text-gray-900">Álvaro</span><br />
          Tailandia · 10 días · Bangkok + Koh Tao
        </div>
      </div>

    </div>
  </div>
</section>

      {/* IDEAS DE VIAJE */}
<motion.section
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
  transition={{ duration: 0.6 }}
  className="w-full mt-20"
>
  {/* CONTENEDOR INTERNO (LIMITA EL CONTENIDO) */}
  <div className="max-w-7xl mx-auto px-4">

    <h2 className="text-2xl md:text-3xl font-semibold text-center mb-3 text-gray-900">
      Ejemplos de viajes optimizados
    </h2>

    <p className="text-center text-gray-600 mb-10 max-w-2xl mx-auto text-sm md:text-base">
      Propuestas reales, ajustados a distintas fechas y preferencias.
    </p>

    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {[
        { 
          title: 'Roma · 3 noches', 
          img: '/roma.png', 
          normal: '420€', 
          optimized: '215€', 
          note: '2 personas · 1 destino · Vuelo + hotel céntrico' 
        },
        { 
          title: 'Praga · Fin de semana', 
          img: '/europa.png', 
          normal: '360€', 
          optimized: '190€', 
          note: '4 personas · 1 destino · Horarios optimizados' 
        },
        { 
          title: 'Tailandia · 10 días', 
          img: '/asia-playa.png', 
          normal: '1.450€', 
          optimized: '820€', 
          note: '4 personas · 3 destinos · Vuelo largo + hoteles' 
        }
      ].map((item) => (
        <div
          key={item.title}
          className="bg-white rounded-3xl shadow-md overflow-hidden flex flex-col"
        >
          <div
            className="h-36 bg-cover bg-center"
            style={{ backgroundImage: `url('${item.img}')` }}
          />
          <div className="p-5 flex flex-col gap-3">
            <h3 className="text-base font-semibold text-gray-900">
              {item.title}
            </h3>

            <div className="flex justify-between items-center text-xs">
              <div className="text-gray-400 line-through">
                Habitual<br />
                <span className="font-medium">{item.normal}</span>
              </div>

              <div className="text-indigo-700 text-right">
                Con Biajando<br />
                <span className="text-lg font-semibold">{item.optimized}</span>
              </div>
            </div>

            <p className="text-[11px] text-gray-500">
              {item.note}
            </p>
          </div>
        </div>
      ))}
    </div>

  </div>
</motion.section>

   {/* PRICING */}
<motion.section
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
  transition={{ duration: 0.6 }}
  className="w-full max-w-7xl mt-20"
>
  <div className="bg-white shadow-sm p-6 md:p-12">

    <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 text-center">
      Servicios y precios
    </h2>

    <p className="mt-4 text-center text-gray-600 max-w-3xl mx-auto text-sm md:text-base">
      Puedes usar Biajando libremente para explorar ideas y recibir resúmenes de viaje.
      <span className="font-semibold text-indigo-700"> Eso es gratis.</span>
      <br />
      Solo hay coste si decides avanzar hasta la propuesta final, con todo optimizado y enlaces listos para reservar.
    </p>

    {/* ================= MOBILE ================= */}
<div className="mt-10 md:hidden">

  {/* RESUMEN DE VIAJE */}
  <div className="rounded-2xl border bg-gray-50 p-5 mb-8">
    <span className="inline-flex px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
      Resumen de viaje
    </span>

    <div className="mt-4 grid grid-cols-2 gap-2 text-sm">
      {[
        'Europa (1)',
        'Europa (multi)',
        'Internacional (1)',
        'Internacional (multi)',
        'Reprice'
      ].map((item) => (
        <div
          key={item}
          className="flex items-center justify-between bg-white rounded-xl px-3 py-2"
        >
          <span className="text-gray-600">{item}</span>
          <span className="inline-flex px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
            Gratis
          </span>
        </div>
      ))}
    </div>
  </div>

  {/* HINT */}
  <div className="mb-3 text-xs text-gray-500 text-center">
    ← Desliza para ver precios por grupo →
  </div>

  {/* VIAJE CERRADO – CARRUSEL */}
  <div className="flex gap-4 overflow-x-auto snap-x snap-mandatory pb-4 -mx-6 px-6">
    {[
      {
        group: '1 persona',
        eu1: '25 €',
        euMultiBase: '25 €',
        euMultiExtra: '+ 10 €/destino',
        int1: '40 €',
        intMultiBase: '40 €',
        intMultiExtra: '+ 15 €/destino',
        reprice: '5 € / 10 €'
      },
      {
        group: '2 personas',
        eu1: '40 €',
        euMultiBase: '40 €',
        euMultiExtra: '+ 10 €/destino',
        int1: '60 €',
        intMultiBase: '60 €',
        intMultiExtra: '+ 15 €/destino',
        reprice: '5 € / 10 €'
      },
      {
        group: 'Hasta 4 personas',
        eu1: '60 €',
        euMultiBase: '60 €',
        euMultiExtra: '+ 15 €/destino',
        int1: '80 €',
        intMultiBase: '80 €',
        intMultiExtra: '+ 20 €/destino',
        reprice: '10 € / 15 €'
      },
      {
        group: 'Hasta 8 personas',
        eu1: '80 €',
        euMultiBase: '80 €',
        euMultiExtra: '+ 20 €/destino',
        int1: '100 €',
        intMultiBase: '100 €',
        intMultiExtra: '+ 25 €/destino',
        reprice: '15 € / 20 €'
      },
      {
        group: 'Más de 8 personas',
        eu1: 'Consúltanos',
        euMultiBase: 'Consúltanos',
        euMultiExtra: '',
        int1: 'Consúltanos',
        intMultiBase: 'Consúltanos',
        intMultiExtra: '',
        reprice: 'A medida'
      }
    ].map((row) => (
      <div
        key={row.group}
        className="min-w-[85%] snap-center rounded-2xl border p-5 bg-white"
      >
        <span className="inline-flex px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold">
          Viaje cerrado
        </span>

        <h3 className="mt-2 font-medium text-gray-900">{row.group}</h3>

        <div className="mt-3 space-y-3 text-sm">
          <div className="flex justify-between">
            <span>Europa (1)</span>
            <span className="font-medium">{row.eu1}</span>
          </div>

          <div className="flex justify-between items-start">
            <span>Europa<br />(multi)</span>
            <div className="text-right">
              <div className="font-medium">{row.euMultiBase}</div>
              {row.euMultiExtra && (
                <div className="text-xs text-gray-500">{row.euMultiExtra}</div>
              )}
            </div>
          </div>

          <div className="flex justify-between">
            <span>Internacional (1)</span>
            <span className="font-medium">{row.int1}</span>
          </div>

          <div className="flex justify-between items-start">
            <span>Internacional<br />(multi)</span>
            <div className="text-right">
              <div className="font-medium">{row.intMultiBase}</div>
              {row.intMultiExtra && (
                <div className="text-xs text-gray-500">{row.intMultiExtra}</div>
              )}
            </div>
          </div>

          <div className="flex justify-between">
            <span>Reprice</span>
            <span className="font-medium">{row.reprice}</span>
          </div>
        </div>
      </div>
    ))}
  </div>
    </div>

    {/* ================= DESKTOP ================= */}
    <div className="hidden md:block mt-10 overflow-x-auto">
      <table className="w-full text-sm border-collapse">
        <thead>
          <tr className="text-left text-gray-700 border-b">
            <th className="py-3 pr-4">Servicio</th>
            <th className="py-3 pr-4">Grupo</th>
            <th className="py-3 pr-4">Europa (1 destino)</th>
            <th className="py-3 pr-4">Europa (multi)</th>
            <th className="py-3 pr-4">Internacional (1)</th>
            <th className="py-3 pr-4">Internacional (multi)</th>
            <th className="py-3 pr-4">Reprice</th>
          </tr>
        </thead>

        <tbody>

          <tr className="bg-gray-50 border-b">
            <td className="py-4 pr-4">
              <span className="inline-flex px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
                Resumen de viaje
              </span>
            </td>
            <td className="py-4 pr-4">Cualquier grupo</td>
            {Array(5).fill(0).map((_, i) => (
              <td key={i} className="py-4 pr-4">
                <span className="inline-flex px-3 py-1 rounded-full bg-green-100 text-green-700 text-xs font-semibold">
                  Gratis
                </span>
              </td>
            ))}
          </tr>

          {[
            ['1 persona','30 €','30 € + 10 €/destino','40 €','40 € + 15 €/destino','5 € / 10 €'],
            ['2 personas','40 €','40 € + 10 €/destino','60 €','60 € + 15 €/destino','5 € / 10 €'],
            ['Hasta 4 personas','60 €','60 € + 15 €/destino','80 €','80 € + 20 €/destino','10 € / 15 €'],
            ['Hasta 8 personas','80 €','80 € + 20 €/destino','100 €','100 € + 25 €/destino','15 € / 20 €'],
            ['Más de 8 personas','Consúltanos','Consúltanos','Consúltanos','Consúltanos','A medida']
          ].map((row) => (
            <tr key={row[0]} className="border-b">
              <td className="py-3 pr-4">
                <span className="inline-flex px-3 py-1 rounded-full bg-indigo-100 text-indigo-700 text-xs font-semibold">
                  Viaje cerrado
                </span>
              </td>
              <td className="py-3 pr-4">{row[0]}</td>
              <td className="py-3 pr-4">{row[1]}</td>
              <td className="py-3 pr-4">{row[2]}</td>
              <td className="py-3 pr-4">{row[3]}</td>
              <td className="py-3 pr-4">{row[4]}</td>
              <td className="py-3 pr-4">{row[5]}</td>
            </tr>
          ))}

        </tbody>
      </table>
    </div>

  </div>
</motion.section>

      {/* FORMULARIO + WHATSAPP */}
<motion.section
  initial="hidden"
  whileInView="visible"
  viewport={{ once: true }}
  variants={fadeUp}
  transition={{ duration: 0.6 }}
className="w-full max-w-7xl mt-20"
>
  <div className="bg-white shadow-sm p-6 flex flex-col gap-6">

    {/* BLOQUE WHATSAPP */}
    <div className="text-center">
      <h2 className="text-xl font-semibold text-gray-900">
        Cuando quieras, empezamos
      </h2>
      <p className="mt-2 text-sm text-gray-600">
        Puedes hablar con nosotros por WhatsApp. Es la forma más rápida de empezar.
      </p>

      <motion.a
href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        initial={{ opacity: 0, y: 12 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        viewport={{ once: true }}
        className="
          mt-4
          inline-flex items-center justify-center gap-3
          px-6 py-3
          rounded-full
          backdrop-blur-md bg-indigo-50
          border border-indigo-100
          text-indigo-700 font-medium
          shadow-sm
          hover:bg-indigo-100
          transition
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="h-5 w-5 fill-green-500"
        >
          <path d="M16.003 3C9.373 3 4 8.373 4 15.003c0 2.651.87 5.103 2.342 7.08L4 29l7.107-2.296a11.94 11.94 0 0 0 4.896 1.045h.001C22.633 27.75 28 22.378 28 15.75 28 9.123 22.633 3 16.003 3z"/>
        </svg>
        <span>Organiza tu viaje por WhatsApp</span>
      </motion.a>
    </div>

    {/* DIVISOR */}
    <div className="flex items-center gap-3 text-xs text-gray-400">
      <div className="flex-1 h-px bg-gray-200" />
      <span>o si lo prefieres</span>
      <div className="flex-1 h-px bg-gray-200" />
    </div>

    {/* FORMULARIO EMAIL */}
    <div>
      <h3 className="text-sm font-medium text-gray-700 text-center">
        Escríbenos por email y te respondemos con una primera propuesta
      </h3>

      <form
        className="mt-4 space-y-3"
        onSubmit={(e) => {
          e.preventDefault();
          window.location.href = `mailto:biajandoconb@gmail.com`;
        }}
      >
        <input
          type="text"
          placeholder="Nombre"
          className="w-full p-3 border rounded-xl text-sm"
          required
        />
        <input
          type="email"
          placeholder="Email"
          className="w-full p-3 border rounded-xl text-sm"
          required
        />
        <textarea
          placeholder="Cuéntanos lo que tengas en mente (aunque no lo tengas claro)"
          rows={4}
          className="w-full p-3 border rounded-xl text-sm"
          required
        />
        <button className="w-full bg-indigo-600 text-white py-3 rounded-xl hover:bg-indigo-700 transition">
          Enviar mensaje
        </button>
      </form>
    </div>

  </div>
</motion.section>

     {/* CTA FLOTANTE WHATSAPP */}
<a
href={whatsappUrl}
  target="_blank"
  rel="noopener noreferrer"
  className="
    fixed bottom-5 right-5 z-50
    flex items-center justify-center
    w-14 h-14 md:w-16 md:h-16
    rounded-full
    bg-green-500/90 backdrop-blur-md
    shadow-xl
    hover:bg-green-600
    transition-all duration-300
    hover:scale-105
  "
  aria-label="Contactar por WhatsApp"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="white"
    className="w-7 h-7 md:w-8 md:h-8"
  >
    <path d="M16 .5C7.4.5.5 7.4.5 16c0 2.8.7 5.5 2.1 7.9L0 32l8.3-2.6c2.3 1.3 5 2.1 7.7 2.1 8.6 0 15.5-6.9 15.5-15.5S24.6.5 16 .5zm0 28.3c-2.4 0-4.7-.7-6.7-1.9l-.5-.3-4.9 1.5 1.6-4.7-.3-.5c-1.2-2-1.9-4.3-1.9-6.8 0-7.1 5.8-12.9 12.9-12.9S28.9 9 28.9 16 23.1 28.8 16 28.8z"/>
  </svg>
</a>
{/* FOOTER */}
<footer className="w-full max-w-7xl mt-24 px-4 md:px-0">
  <div className="md:p-8">

    {/* TOP */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">

      {/* MARCA */}
      <div className="flex flex-col gap-2 md:gap-3">
        <div className="flex items-center gap-2">
          <img
            src="/logo-biajando.png"
            alt="Biajando con B"
            className="h-8 md:h-9"
          />
          <span className="font-semibold text-indigo-700">
            Biajando con B
          </span>
        </div>

        {/* Descripción desktop */}
        <p className="text-sm text-gray-600 max-w-xs hidden md:block">
          Viajes personalizados, pensados para encajar contigo.
          Sin líos, sin comparar y con atención directa..
        </p>

        {/* Descripción móvil */}
        <p className="text-sm text-gray-600 md:hidden">
          Viajes personalizados, pensados para encajar contigo.
        </p>

        {/* INSTAGRAM */}
        <a
          href="https://www.instagram.com/biajando_es/"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:underline w-fit"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-4 h-4"
          >
            <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5A4.25 4.25 0 0 0 7.75 20.5h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5A4.25 4.25 0 0 0 16.25 3.5h-8.5z"/>
            <path d="M12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 1.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM17.25 6a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"/>
          </svg>
          Instagram
        </a>

        {/* TIKTOK */}
        <a
          href="https://www.tiktok.com/@biajandoconb"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 text-sm text-indigo-600 hover:underline w-fit"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-4 h-4"
          >
            <path d="M19.589 6.686a4.793 4.793 0 01-3.77-4.231h-3.06v13.205a2.338 2.338 0 11-2.338-2.338c.17 0 .336.02.495.058v-3.115a5.45 5.45 0 00-.495-.023 5.453 5.453 0 105.453 5.453V9.356a8.06 8.06 0 004.77 1.573V7.869a4.82 4.82 0 01-1.055-.183z"/>
          </svg>
          TikTok
        </a>

      </div>

      {/* CONTACTO */}
      <div className="flex flex-col gap-1 md:gap-2 text-sm text-gray-600">
        <h4 className="font-medium text-gray-900">Contacto</h4>
        <span>WhatsApp: +34 641 36 98 66</span>
        <span>Email: biajandoconb@gmail.com</span>
      </div>

      {/* LEGAL */}
      <div className="flex flex-col gap-1 md:gap-2 text-sm">
        <h4 className="font-medium text-gray-900">Legal</h4>

        <button
          onClick={() => setPage("terms")}
          className="text-left text-gray-600 hover:underline"
        >
          Términos y Condiciones
        </button>

        <button
          onClick={() => setPage("privacy")}
          className="text-left text-gray-600 hover:underline"
        >
          Política de Privacidad
        </button>

        <button
          onClick={() => setPage("cookies")}
          className="text-left text-gray-600 hover:underline"
        >
          Cookies
  </button>
</div>

    </div>

    {/* BOTTOM */}
    <div className="mt-8 pt-4 md:border-t text-xs text-gray-400 text-center">
      © 2025 Biajando con B de Barato. Todos los derechos reservados.
    </div>
<CookieBanner />
  </div>
</footer>
    </div>
  );
};

export default LandingPage;
